import { useTranslations } from 'next-intl'
import { Link } from '@repo/web-ui/components/link'

import type { ClubhouseItem } from '../../../_components/constants'
import { UserAvatar } from '@web/app/[locale]/(web)/masterfeed/_components/user-avatar'
import { useClubhousesGetDetailsQuery } from '@web/gen/clubhouses'

export const ClubhouseCard = (clubhouse: ClubhouseItem) => {
  const t = useTranslations('pages.clubhouse.sidebar')

  const { data: membersTotal } = useClubhousesGetDetailsQuery(
    {
      input: {
        clubhouseSlug: clubhouse.slug,
      },
    },
    {
      select: data => data?.clubhousesGetDetails?.clubhouse?.membersTotal,
    },
  )

  return (
    <Link
      href={clubhouse.href}
      className="text-cf-sf-gray-1050 bg-cf-white rounded-2 flex w-full flex-row items-center justify-between border border-[#0A0A0B1A] p-4 shadow-[0px_2px_4px_0px_rgba(0,0,0,0.10)] transition duration-300 ease-out hover:scale-105 active:shadow-none"
    >
      <div>
        <div className="text-16 font-semibold leading-[18px]">{clubhouse.title}</div>
        <div className="mt-2 flex flex-row items-center gap-1">
          <div className="flex items-center">
            <UserAvatar
              avatarUrl={`https://avatar.iran.liara.run/public/${1}`}
              size="xSmall"
              className="border-cf-white border"
            />
            <UserAvatar
              className="border-cf-white -ml-1 border"
              avatarUrl={`https://avatar.iran.liara.run/public/${2}`}
              size="xSmall"
            />
            <UserAvatar
              className="border-cf-white -ml-1 border"
              avatarUrl={`https://avatar.iran.liara.run/public/${3}`}
              size="xSmall"
            />
          </div>
          <div className="text-12 capitalize leading-[14px] text-[#4B5563]">
            {membersTotal} {t('members')}
          </div>
        </div>
      </div>
      <div style={{ '--color': clubhouse.bgColorHex ?? '' }} className="h-8 w-8 text-[--color]">
        {clubhouse.icon}
      </div>
    </Link>
  )
}
